import React,{useState} from 'react';
import { Calendar , momentLocalizer } from 'react-big-calendar';
import AddReserva from "./AddReserva";
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import HookReservas from "../../Hooks/useReservas";
import moment from 'moment';
import "moment/locale/es-mx";
import "./styles.css";

const Booking = () => 
{
    const styles=
    {
        Fab:
        {
            position:"fixed",
            zIndex:2,
            bottom:20,
            right:20,
            backgroundColor:"#ffffff"
        }
    }

    const [isOpenAdd, setisOpenAdd] = useState(false)
    const localizer = momentLocalizer(moment);
    const Reservas=HookReservas();

    const textos=
    {
        allDay: 'Todo el día',
        previous: '<',
        next: '>',
        today: 'Hoy',
        month: 'Mes',
        week: 'Semana',
        day: 'Día',
        agenda: 'Agenda',
        date: 'Fecha',
        time: 'Hora',
        event: 'Evento',
        noEventsInRange: "No existen reservas en este rango de fecha",
        showMore: total => `+ reservas adicionales (${total})`
      };

    return (
        <div>
            <Fab style={styles.Fab} onClick={() =>setisOpenAdd(true)}>
                <AddIcon/>
            </Fab>  
            <Calendar localizer={localizer} messages={textos} events={Reservas} startAccessor="start"endAccessor="end"/>
            <AddReserva isOpen={isOpenAdd} onClose={() => setisOpenAdd(false)}/>
        </div>
    )
}

export default Booking;

